export default __webpack_public_path__ + "static/media/copy-light.c65740e3.svg";